import { j as i } from "../../../utils-BdNIfrGQ.js";
import { D as e } from "../../../Div-spVpsZsH.js";
import "../../../NavLink-D9Qfouy1.js";
import { E as a } from "../../../ExternalLink-CwLUkrFF.js";
import "../../../HamburgerMenu-Bi4wrZqX.js";
import { B as n } from "../../../BannerImage-BP0Y6QiW.js";
import "../../../theme/provider/ThemeProvider.mjs";
import "react";
import "../../../Div.skeleton-DLnqOZrU.js";
import "../../../Flex-BA9xHq_p.js";
import "../../../Grid-DJGISvmf.js";
import "../../../ScrollToGrid-6uyEoyhk.js";
import "../../avatar/Avatar.mjs";
import { u as l } from "../../../ResponsiveProvider-C06ERneB.js";
import "../../../Button-CzIiGCVn.js";
import "../../../toast-DrFMmSLk.js";
import "react-dom";
import "../../../Button.skeleton-D0Onk1OP.js";
const N = ({ bannerImage: r, target: o }) => {
  const { isMobile: s } = l(), m = !!o, p = m && o, t = /* @__PURE__ */ i.jsx(n, { src: s ? r.mobile : r.desktop, alt: "" });
  return /* @__PURE__ */ i.jsxs(e, { className: "z-1 *:max-h-[320px] mt-[-56px]", children: [
    p && /* @__PURE__ */ i.jsx(a, { href: o.url, "aria-label": o.label, width: "full", children: t }),
    !m && t
  ] });
};
export {
  N as default
};
